const cleanDuplicatedImages = images => {
  const uuids = {};
  return images.filter(image => {
    if (!uuids[image.entity?.uuid]) {
      uuids[image.entity?.uuid] = true;
      return true;
    }
    return false;
  });
};

const isPortrait = image => {
  return image?.entity?.mediaImage?.width < image?.entity?.mediaImage?.height;
};

const removePortraitImages = images => {
  return images.filter((image, index) => index === 0 || !isPortrait(image));
};

const getMainImages = content => {
  let images = [];
  if (content) {
    if (content.promoImage?.[0]?.entity) {
      images = content.promoImage;
    }
    if (content.promoImageBackground?.entity) {
      images.push(content.promoImageBackground);
    }
    if (content.image?.entity) {
      images.push(content.image);
    }
  }
  return images;
};

const getParagraphImages = (content, maxItems) => {
  let images = [];
  content.mainContent?.forEach(paragraph => {
    if (paragraph?.entity && images.length < maxItems) {
      switch (paragraph.entity.type) {
        case 'ParagraphImageToolkitElement': {
          if (!isPortrait(paragraph.entity.image)) {
            images.push(paragraph.entity.image);
          }
          break;
        }
        case 'ParagraphImageGroup': {
          images = images.concat(removePortraitImages(paragraph.entity.images));
          break;
        }
        case 'ParagraphGalleryInlineElement': {
          images = images.concat(
            removePortraitImages(paragraph.entity.photoGallery?.entity?.images)
          );
          break;
        }
        case 'ParagraphSlide': {
          images = images.concat(
            removePortraitImages(paragraph.entity.slideImage)
          );
          break;
        }
        case 'ParagraphContentPackage': {
          paragraph.entity.contentPackageStack?.forEach(childContent => {
            images = images.concat(
              removePortraitImages(getMainImages(childContent.entity))
            );
          });
          break;
        }
        default: {
          break;
        }
      }
    }
  });
  return images.slice(0, maxItems);
};

const getAllImagesFromContent = (content, maxItems = 5) => {
  // First we get Promo image (there can be 5 at max.)
  let images = getMainImages(content);
  const itemsLeft = maxItems - images.length;
  if (itemsLeft > 0 && content?.bundle) {
    switch (content.bundle) {
      case 'article':
      case 'hub_page':
      case 'show':
      case 'vertical_slideshow_gallery': {
        images = images.concat(getParagraphImages(content, itemsLeft + 2));
        break;
      }
      case 'photo_gallery': {
        content.images.forEach(image => {
          if (images.length <= maxItems + 2 && !isPortrait(image)) {
            images.push(image);
          }
        });
        break;
      }
      default: {
        break;
      }
    }
  }
  images = cleanDuplicatedImages(images);
  return images.slice(0, maxItems);
};

module.exports = {
  getMainImages,
  getAllImagesFromContent
};
